import React from 'react';

const DataAiSVG = ({ color = 'black', className, ...props }) => {
  return (
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="14"
    //   height="14"
    //   viewBox="0 0 14 14"
    //   fill="none"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M4.375 13.125V0.875H5.6875C5.92944 0.875 6.125 0.679 6.125 0.4375C6.125 0.196 5.92944 0 5.6875 0H2.1875C1.94556 0 1.75 0.196 1.75 0.4375C1.75 0.679 1.94556 0.875 2.1875 0.875H3.5V13.125H2.1875C1.94556 13.125 1.75 13.321 1.75 13.5625C1.75 13.804 1.94556 14 2.1875 14H5.6875C5.92944 14 6.125 13.804 6.125 13.5625C6.125 13.321 5.92944 13.125 5.6875 13.125H4.375ZM2.1875 1.75C2.42944 1.75 2.625 1.946 2.625 2.1875C2.625 2.429 2.42944 2.625 2.1875 2.625H0.875V11.375H2.1875C2.42944 11.375 2.625 11.571 2.625 11.8125C2.625 12.054 2.42944 12.25 2.1875 12.25H0.875C0.392 12.25 0 11.858 0 11.375V2.625C0 2.142 0.392 1.75 0.875 1.75H2.1875ZM14 2.625C14 2.142 13.608 1.75 13.125 1.75H5.6875C5.44556 1.75 5.25 1.946 5.25 2.1875C5.25 2.429 5.44556 2.625 5.6875 2.625H13.125V11.375H5.6875C5.44556 11.375 5.25 11.571 5.25 11.8125C5.25 12.054 5.44556 12.25 5.6875 12.25H13.125C13.608 12.25 14 11.858 14 11.375V2.625Z"
    //     fill={color}
    //   />
    // </svg>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='19'
      height='20'
      viewBox='0 0 19 20'
      fill='none'
    >
      <path
        d='M9.67239 5.25103C10.8118 5.25103 11.7354 4.32739 11.7354 3.18802C11.7354 2.04864 10.8118 1.125 9.67239 1.125C8.53302 1.125 7.60938 2.04864 7.60938 3.18802C7.60938 4.32739 8.53302 5.25103 9.67239 5.25103Z'
        stroke={color}
      />
      <path
        d='M16.4458 12.4007C17.5852 12.4007 18.5088 11.477 18.5088 10.3377C18.5088 9.1983 17.5852 8.27466 16.4458 8.27466C15.3065 8.27466 14.3828 9.1983 14.3828 10.3377C14.3828 11.477 15.3065 12.4007 16.4458 12.4007Z'
        stroke={color}
      />
      <path
        d='M9.67239 19.125C10.8118 19.125 11.7354 18.2014 11.7354 17.062C11.7354 15.9226 10.8118 14.999 9.67239 14.999C8.53302 14.999 7.60938 15.9226 7.60938 17.062C7.60938 18.2014 8.53302 19.125 9.67239 19.125Z'
        stroke={color}
      />
      <path
        d='M2.81302 16.0978C3.95239 16.0978 4.87603 15.1742 4.87603 14.0348C4.87603 12.8954 3.95239 11.9718 2.81302 11.9718C1.67364 11.9718 0.75 12.8954 0.75 14.0348C0.75 15.1742 1.67364 16.0978 2.81302 16.0978Z'
        stroke={color}
      />
      <path
        d='M2.81302 8.03009C3.95239 8.03009 4.87603 7.10644 4.87603 5.96707C4.87603 4.8277 3.95239 3.90405 2.81302 3.90405C1.67364 3.90405 0.75 4.8277 0.75 5.96707C0.75 7.10644 1.67364 8.03009 2.81302 8.03009Z'
        stroke={color}
      />
      <path
        d='M9.67382 11.1778C10.5939 11.1778 11.3398 10.4319 11.3398 9.51177C11.3398 8.59166 10.5939 7.84576 9.67382 7.84576C8.75371 7.84576 8.00781 8.59166 8.00781 9.51177C8.00781 10.4319 8.75371 11.1778 9.67382 11.1778Z'
        stroke={color}
      />
      <path d='M4.58594 4.91429L7.68046 3.71973' stroke={color} />
      <path d='M11.125 4.6626L14.9816 8.89143' stroke={color} />
      <path d='M15.1894 11.9683L11.1484 15.6158' stroke={color} />
      <path d='M3.94531 7.68982L8.39391 15.4456' stroke={color} />
      <path d='M4.64062 14.9954L7.61463 16.3743' stroke={color} />
      <path d='M3.58594 12.1207L8.55916 4.92139' stroke={color} />
      <path d='M4.71094 6.77527L8.19184 8.74258' stroke={color} />
      <path d='M11.3438 9.69965L14.3886 9.93005' stroke={color} />
      <path d='M9.67188 11.1813L9.67542 14.9954' stroke={color} />
    </svg>
  );
};

export default DataAiSVG;
